import {
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    Renderer2,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { $state } from 'app/ajs-upgraded-providers';

import {
    fromEvent,
    Subscription
} from 'rxjs';

import {
    EnvironmentInfoService
} from 'src/app/core';

@Component({
	standalone: true,
    selector: 'app-barcode',
    templateUrl: './barcode.component.html',
    styleUrls: ['./barcode.component.scss'],
    imports: [
        FormsModule,
        MatButtonModule,
        MatIcon
    ]
})
export class BarcodeComponent {
    private readonly environmentInfoService = inject(EnvironmentInfoService);
    private readonly renderer = inject(Renderer2);
    private readonly state = inject($state);

    protected currentModuleClass = `barcode-icon-${this.state.current.name.split('.')[1]}`;
    protected isAppleMobile = this.environmentInfoService.isAppleMobile();
    protected barcodeInput: string =  "";

    @Input() hideButton: any;
    @Input() idSelector: string = 'barcodeInput';
    @Output() onSubmitBarcode = new EventEmitter<string>();
    keyPressSubscription?: Subscription;

    ngOnInit() {
        if (!this.isAppleMobile) {
          this.keyPressSubscription = fromEvent(window, 'keypress')
          .subscribe((event: any&KeyboardEvent) => this.onKeyPress(event));
        }
    }

    ngOnDestroy() {
        if (this.keyPressSubscription) {
          this.keyPressSubscription.unsubscribe();
        }
    }

    onKeyPress(event: KeyboardEvent) {
        if (event.target instanceof HTMLBodyElement) {
            switch (event.code) {
                case 'Enter':
                    this.barcodeSubmitted();
                    break;
                case 'Escape':
                    this.barcodeInput = '';
                    break;
                default:
                    this.barcodeInput += event.key;
                    break;
            }
        }
    }

    barcodeSubmitted() {
        if(this.barcodeInput.length) {
            this.onSubmitBarcode.emit(this.barcodeInput);
            this.barcodeInput = "";
        }
    };

    // APPLE WORKAROUND
    focusBarcodeInput() {
        const barcodeInput = this.renderer.selectRootElement('#'+this.idSelector);
        barcodeInput.focus();
        barcodeInput.value = '';
    };
}
